export default "__VITE_ASSET__dqRIWHUk__"